/**
 * @(#)2019/11/14.
 * 封装与html相关的功能
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import { random, get, merge } from "./index";
import { accept } from "./fileInput";
import { isObject } from "lodash";
import { message } from "antd";

const body = document.body;

/**
 * 对象转html参数
 *
 * @param {*} obj
 */
export const objToHtmlParam = function (obj, joinMark = " ", paramMark = "=") {
  const result = [];
  for (let item of Object.entries(obj)) {
    const [key, value] = item;
    if (isObject(value)) {
      result.push(`${key}="${objToHtmlParam(value, ";", ":")}"`);
    } else {
      const val = value + "";
      result.push(`${key}${paramMark}${val}`);
    }
  }
  return result.join(joinMark);
};

/**
 * 校验文件大小
 *
 * @param {FileList} files
 * @param {string} msg 异常消息
 * @param {number} maxSize
 */
const checkFileSize = function (files, maxSize, msg) {
  if (files == null) return true;
  const maxFileSize = Number(maxSize);
  for (let file of [...files]) {
    const size = file.size;
    if (maxFileSize !== 0 && size / (1024 * 1024) > maxFileSize) {
      message.error(msg);
      return false;
    }
  }
  return true;
};

/**
 * 生成input节点在body上
 *
 * @param callbak 点击回调
 * @param extra 扩展参数
 */
export const createInputHtml = function (callbak = function () {}, extra = {}) {
  const id = random();
  const type = get(extra, "type", "*");
  const maxSize = get(extra, "fileSize", 0);
  const msg = get(
    extra,
    "message",
    `超出文件限制大小，文件大小限制为 ${maxSize}MB`
  );
  const inputParam = {
    id,
    accept: accept(type),
    type: "file",
    style: {
      width: 0,
      height: 0,
      position: "fixed",
      opacity: 0,
    },
  };
  const inputHtml = `<input ${objToHtmlParam(inputParam)}">`;
  body.insertAdjacentHTML("afterbegin", inputHtml);
  const dom = document.querySelector(`#${id}`);
  dom.addEventListener("change", async () => {
    const files = dom.files;
    if (checkFileSize(files, maxSize, msg)) {
      await callbak(dom.files, dom);
    }
  });
  return dom;
};



// WEBPACK FOOTER //
// ./src/yx-widget/utils/htmlTools.js